export enum Topic {
	SubmitEvent = 'tracking.bct.submitEvent',
	MergeEvent = 'tracking.bct.addToPageImpression',
	Unsupported = 'tracking.bct.unsupported',
	AddActionToEvent = 'tracking.bct.addActionToEvent'
}
